import {
    buildAttendanceShareText,
    buildViewingStudentShareText,
} from "./attendanceExportUtils";

export default function useAttendanceShareActions({
    currentDate,
    dailyStats,
    filteredStudents,
    openAlert,
    openConfirm,
    viewingStudent,
}) {
    const handleShareStats = async () => {
        const text = buildAttendanceShareText({
            currentDate,
            dailyStats,
            filteredCount: filteredStudents.length,
        });

        // [MODIFIED] 무조건 클립보드 복사만 수행 (시스템 공유 제거)
        openConfirm("출석 현황 복사", "현재 출석 현황을 클립보드에 복사하시겠습니까?", () => {
            navigator.clipboard.writeText(text).then(() => openAlert("출석 현황이 복사되었습니다! 📋", "알림")).catch(() => openAlert("복사 실패", "오류"));
        });
    };

    const handleShareViewingStudent = () => {
        if (!viewingStudent) return;
        openConfirm("학생 정보 공유", `${viewingStudent.name} 학생의 정보를 복사하시겠습니까?`, () => {
            const shareText = buildViewingStudentShareText({ viewingStudent });
            navigator.clipboard.writeText(shareText);
            openAlert("정보가 복사되었습니다!", "알림");
        });
    };

    return {
        handleShareStats,
        handleShareViewingStudent,
    };
}
